import router from '@/router';
import areasService from '../services/areas.service';
import { ForgeArea } from '@/scripts/js/forgeModels';
import store from '@/store';
import { getViewPage3D } from '@/scripts/js/forgeviewer';
import { FACILITY_REQUEST } from '@/utils/http/RequestRegistry';

export const AREAS = {
	namespaced: true,
	state: {
		entries: [],
		total: 0,
		loading: false,
		updateLoading: false,
		options: {},
		selectedAreaId: null,
		defaultAreaId: null,
	},
	getters: {
		GET_ENTRIES(state) {
			return state.entries;
		},
		GET_TOTAL(state) {
			return state.total;
		},
		GET_LOADING(state) {
			return state.loading;
		},
		GET_UPDATE_LOADING(state) {
			return state.updateLoading;
		},
		GET_OPTIONS(state) {
			return state.options;
		},
		GET_DEFAULT_AREA_ID(state) {
			return state.defaultAreaId;
		},
		GET_SELECTED_AREA_ID(state) {
			return state.selectedAreaId;
		},
		GET_SELECTED_AREA(state) {
			return state.entries.find((area) => area.id === state.selectedAreaId);
		},
	},
	mutations: {
		SET_ENTRIES(state, value) {
			state.entries = value;
		},
		SET_TOTAL(state, value) {
			state.total = value;
		},
		SET_LOADING(state, value) {
			state.loading = value;
		},
		SET_UPDATE_LOADING(state, value) {
			state.updateLoading = value;
		},
		SET_OPTIONS(state, value) {
			state.options = value;
		},
		SET_DEFAULT_AREA_ID(state, value) {
			state.defaultAreaId = value;
		},
		SET_SELECTED_AREA_ID(state, value) {
			state.selectedAreaId = value;
		},
	},
	actions: {
		async GET_ENTRIES({ commit, state }) {
			state.options.facilityId = router.currentRoute.params.id;
			commit('SET_LOADING', true);
			const response = await areasService.get(state.options, FACILITY_REQUEST);
			let areas = response.data.items.map(area => {
				let a = Object.assign(new ForgeArea(), area);
				a.parseContent();
				return a;
			})
			commit('SET_ENTRIES', areas);
			commit('SET_TOTAL', response.data.total);
			commit('SET_LOADING', false);
		},
		async ADD_ENTRY(_, data) {
			return new Promise((resolve, reject) => {
				areasService.add(data)
					.then((response) => {
						resolve(response);
					})
					.catch((error) => {
						reject(error);
					});
			});
		},
		async UPDATE_ENTRY(_, data) {
			return new Promise((resolve, reject) => {
				areasService.update(data)
					.then((response) => {
						resolve(response);
					})
					.catch((error) => {
						reject(error);
					});
			});
		},
		async DELETE_ENTRY(_, id) {
			return new Promise((resolve, reject) => {
				areasService.del(id)
					.then((response) => {
						resolve(response);
					})
					.catch((error) => {
						reject(error);
					});
			});
		},
		async UPDATE_SELECTED_AREA_ID({ commit }, id) {
			return new Promise((resolve, reject) => {
				areasService.updateSelectedAreaId({
					areaId	: id,
					facilityId: router.currentRoute.params.id,
				}).then(() => {
					commit('SET_SELECTED_AREA_ID', id);
					resolve();
				}).catch(() => {
					reject();
				});
			});
		},
		LOAD_AREA_IN_VIEWER(_, {
			area,
			onAreaLoaded = null,
			requestOwner = null,
			shouldExecute = null,
		}) {
			const isRequestCurrent = () => !shouldExecute || shouldExecute();
			const settleOwnedStaleLoad = () => {
				if (
					typeof onAreaLoaded === 'function'
					&& onAreaLoaded.tagSpatialRequestOwner === requestOwner
				) {
					onAreaLoaded();
				}
			};
			if (!isRequestCurrent()) {
				settleOwnedStaleLoad();
				return;
			}

			if (!getViewPage3D()) {
				this.$store.commit('SET_VIEW_1_TYPE', '3d');
				this.$store.commit('SET_IS_VIEW_1_VISIBLE', true);
				this.$store.commit('SET_IS_VIEW_2_VISIBLE', false);
				this.$store.commit('SET_IS_VIEW_3_VISIBLE', false);
				this.$store.commit('SET_IS_VIEW_4_VISIBLE', false);
			}

			setTimeout(() => {
				if (!isRequestCurrent()) {
					settleOwnedStaleLoad();
					return;
				}
				let page3d = getViewPage3D();
				page3d.loadArea(area);
			}, 100);
		},
		REMOVE_TAGS_OUTSIDE_AREA({ state }, id) {
			let area = state.entries.find((area) => area.id === id);
			let bounding = area.boundingBox;

			return areasService.removeTagsOutsideArea(id, {
				min: store.state.forgeService.view3dToWorld(bounding.min),
				max: store.state.forgeService.view3dToWorld(bounding.max)
			});
		}
	}

}
